<template>
  <div class="popup-recover-password">
    <Modal-base
      :title="title"
      :show="show"
      iconValue="password-open"
      :colorHeader="isCustomOwner ? 'blueVolvo' : 'primary'"
    >
      <!-- Body -->
      <template v-slot:body>
        <!-- enter email -->
        <v-text-field
          v-if="enterEmail && !passwordChanged"
          v-model="emailToSend"
          required
          counter="40"
          maxlength="40"
          :label="$t('forms.email')"
        ></v-text-field>

        <!-- email sended -->
        <v-layout column v-else-if="!enterEmail && !passwordChanged">
          <v-layout>
            <F2gIcon
              value="email"
              class="pr-4"
              :height="24"
              :width="24"
              stroke="black"
              :strokeWidth="3"
            />
            <span
              class="text"
              v-html="$t('common.emailSentTo', { email: email })"
            ></span>
          </v-layout>
          <br />
          <span class="text">{{ $t("common.stepsToRecoverPassword") }}</span>
        </v-layout>

        <!-- password changed -->
        <div v-else>
          <span class="text">{{ $t("common.passwordChanged") }}</span>
        </div>
      </template>

      <!-- Buttons -->
      <template v-slot:buttons>
        <v-spacer></v-spacer>
        <v-btn
          v-if="enterEmail"
          color="primary"
          text
          class="button-rounded"
          @click="$emit('closePopUp')"
          >{{ $t("cancel") }}</v-btn
        >
        <transition name="fade">
          <v-btn
            v-if="enterEmail && emailToSend.length > 0"
            color="primary"
            text
            class="button-rounded"
            @click="$emit('sentEmail', emailToSend)"
            >{{ $t("common.sendEmail") }}</v-btn
          >
        </transition>
        <v-btn
          v-if="!enterEmail"
          color="primary"
          text
          class="button-rounded"
          @click="$emit('closePopUp')"
          >{{ $t("common.accept") }}</v-btn
        >
      </template>
    </Modal-base>
  </div>
</template>

<script>
import ModalBase from "@/flit2go-web-core/components/modal-base.vue";

export default {
  name: "PopUp-recover-password",
  components: {
    ModalBase,
  },
  data: () => ({
    emailToSend: "",
  }),
  props: {
    email: String,
    show: Boolean,
    enterEmail: Boolean,
    passwordChanged: Boolean,
    isCustomOwner: { default: false, required: false, type: Boolean },
  },
  computed: {
    title() {
      return !this.passwordChanged
        ? this.$t("common.passwordRecovery")
        : this.$t("common.passwordChange");
    },
  },
};
</script>
